/**
 * RA Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadOnlyProfileProjectDTO } from './readOnlyProfileProjectDTO';
import { ReadOnlyProfileCompetencyDTO } from './readOnlyProfileCompetencyDTO';


export interface ReadOnlyProfileDTO { 
    employeeName?: string;
    seniority?: ReadOnlyProfileDTO.SeniorityEnum;
    position?: string;
    projects?: Array<ReadOnlyProfileProjectDTO>;
    competencies?: Array<ReadOnlyProfileCompetencyDTO>;
}
export namespace ReadOnlyProfileDTO {
    export type SeniorityEnum = 'JUNIOR' | 'JUNIOR_MEDIOR' | 'MEDIOR' | 'MEDIOR_SENIOR' | 'SENIOR';
    export const SeniorityEnum = {
        Junior: 'JUNIOR' as SeniorityEnum,
        JuniorMedior: 'JUNIOR_MEDIOR' as SeniorityEnum,
        Medior: 'MEDIOR' as SeniorityEnum,
        MediorSenior: 'MEDIOR_SENIOR' as SeniorityEnum,
        Senior: 'SENIOR' as SeniorityEnum
    };
}


